import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  ClickableIcon, SecondaryTextLgBold, Icon, BorderlessKeyInput,
  SecondaryTextXs, TagText
} from 'atoms';
import {
  MobileSidebarFilterWrapper, FlexBoxWrapper, P4, CustomBackgroundWrapper, FlexCenterWrapper,
  Ml2, BorderBottomWrapper, FlexCenterBetweenWrapper, Mr3, Ml6, Mt10, Py3, NotPaddedGrowWrapper,
  FlexCenterJustifyCenterWrapper, Py2, PrimaryBackground50Wrapper, Mx2
} from 'wrappers';
import { TextButton, SolidButton } from 'molecules';
import { XSvg, BackArrowSvg, MagnifyingGlassSvg } from 'components/icons';
import { escapedRegex } from 'utils';
import { GreenTickSvg } from 'components/icons';

export const definition = {
  name: 'MobileSideDropdown',
  controller: Controller,
  initialProps: ({ isVisible, title, placeholder, selectedOptionIds, options, noTagIds, makeReadyCategory }) => ({ isVisible, title, placeholder, selectedOptionIds, options, searchTerm: '', noTagIds, makeReadyCategory }),
  props: internalState,
  elements: [
    {
      wrapper: MobileSidebarFilterWrapper,
      name: 'Wrapper',
      displayState: ({ isVisible }) => ({ isVisible, hideBackground: true }),
      elements: [
        {
          wrapper: FlexBoxWrapper,
          name: 'Wrapper',
          elements: [
            {
              component: wrap(ClickableIcon, P4),
              name: 'CloseIcon',
              bindings: ({ selectedOptionIds, noTagIds }) => ({ selectedOptionIds, noTagIds }),
              displayValue: ({ }) => XSvg({ width: 24, height: 24, color: '#FFFFFF' })
            },
            {
              wrapper: CustomBackgroundWrapper,
              name: 'ButtonsWrapper',
              displayState: ({ }) => ({ flexDirection: 'column', width: '100%', height: '100vh', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: wrap(FlexCenterWrapper, P4),
                  name: 'TitleWrapper',
                  elements: [
                    {
                      component: ClickableIcon,
                      name: 'GoBack',
                      bindings: ({ selectedOptionIds, noTagIds }) => ({ selectedOptionIds, noTagIds }),
                      displayValue: ({ }) => BackArrowSvg({})
                    },
                    {
                      component: wrap(SecondaryTextLgBold, Ml2),
                      name: 'Title',
                      renderIf: ({ title }) => !!title,
                      displayValue: ({ title }) => title
                    },
                  ]
                },
                {
                  component: wrap(BorderBottomWrapper, Mt10),
                  name: 'BorderTop',
                  displayValue: ({ }) => ''
                },
                {
                  wrapper: FlexCenterBetweenWrapper,
                  name: 'SearchWrapper',
                  elements: [
                    {
                      component: wrap(wrap(BorderlessKeyInput, Mr3), Ml6),
                      name: 'SearchInput',
                      bindings: ({ inputVal, placeholder, showDropdown }) => ({ showDropdown, value: inputVal, placeholder: placeholder ?? "Search..." })
                    },
                    {
                      wrapper: CustomBackgroundWrapper,
                      name: 'Search',
                      isButton: true,
                      bindings: ({ inputVal }) => ({ inputVal }),
                      displayState: ({ }) => ({ borderRadius: '10px 0px 0px 10px', height: '37px', width: '57px', background: window?.settings?.primary_color ?? '#1DBD6B', alignItems: 'center', justifyContent: 'center' }),
                      elements: [
                        {
                          component: Icon,
                          name: 'Icon',
                          displayValue: ({ }) => MagnifyingGlassSvg({ color: '#FFFFFF', width: 16, height: 16 })
                        },
                      ]
                    }
                  ]
                },
                {
                  component: BorderBottomWrapper,
                  name: 'BorderBottom',
                  displayValue: ({ }) => ''
                },
                {
                  wrapper: wrap(FlexCenterBetweenWrapper, P4),
                  name: 'ClearAllHeader',
                  elements: [
                    {
                      component: SecondaryTextXs,
                      name: 'Selected',
                      displayValue: ({ selectedOptionIds }) => `${selectedOptionIds?.length ?? 0} Selected`
                    },
                    {
                      component: TextButton,
                      name: 'ClearAll',
                      bindings: ({ selectedOptionIds, options }) => ({ mobileSmall: true, options, selectedOptionIds, title: selectedOptionIds?.length ?? 0 > 0 ? 'Clear all' : 'Select all' }),
                    }
                  ]
                },
                {
                  wrapper: NotPaddedGrowWrapper,
                  name: 'OptionsWrapper',
                  elements: [
                    {
                      wrapper: wrap(FlexCenterBetweenWrapper, Py3),
                      name: 'NoTag',
                      isButton: true,
                      bindings: ({ noTagIds, makeReadyCategory }) => ({ noTagIds, makeReadyCategory }),
                      elements: [
                        {
                          component: wrap(wrap(TagText, FlexBoxWrapper), Mx2),
                          name: 'TagText',
                          displayValue: ({ }) => 'No Tag'
                        },
                        {
                          component: wrap(Icon, Mx2),
                          name: 'Checkbox',
                          renderIf: ({ noTagIds, makeReadyCategory }) => noTagIds?.includes(makeReadyCategory?.id),
                          displayValue: ({ }) => GreenTickSvg({})
                        },
                      ]
                    },
                    {
                      wrapper: wrap(FlexCenterBetweenWrapper, Py3),
                      name: 'Option',
                      isButton: true,
                      isListOf: {
                        option: ({ options, pageNumber, searchTerm }) => options.filter(o => escapedRegex(searchTerm).test(o.displayName)).slice(0, pageNumber * 35)
                      },
                      bindings: ({ option, selectedOptionIds, singleSelect }) => {
                        const isSelected = selectedOptionIds.includes(option.id);
                        return { icon: option.icon, image: option.image, id: option.id, isSelected, selectedOptionIds, singleSelect, text: option.displayName }
                      },
                      elements: [
                        {
                          component: wrap(wrap(TagText, FlexBoxWrapper), Mx2),
                          name: 'TagText',
                          displayState: ({ option }) => ({ color: option.color }),
                          displayValue: ({ option }) => option.name ?? ''
                        },
                        {
                          component: wrap(Icon, Mx2),
                          name: 'Checkbox',
                          renderIf: ({ option, selectedOptionIds }) => selectedOptionIds.includes(option.id),
                          displayValue: ({ }) => GreenTickSvg({})
                        },
                      ]
                    },
                    {
                      component: wrap(wrap(wrap(TextButton, FlexCenterJustifyCenterWrapper), Py2), PrimaryBackground50Wrapper),
                      name: 'LoadMore',
                      renderIf: ({ options, pageNumber, searchTerm }) => options.filter(o => escapedRegex(searchTerm).test(o.displayName)).length > 35 * pageNumber,
                      bindings: ({ pageNumber }) => ({ mobileSmall: true, title: 'Load more...', pageNumber })
                    }
                  ]
                },
                {
                  component: wrap(wrap(SolidButton, FlexCenterWrapper), P4),
                  name: 'Button',
                  bindings: ({ selectedOptionIds, noTagIds }) => ({ selectedOptionIds, title: `Apply filters`, noTagIds }),
                },
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);